import { Link } from "react-router-dom";
import { ShoppingBag, Star, ArrowRight } from "lucide-react";

const R2 = "https://photos.leonowak.org/site";

export const TiendaMembresiasCTA = () => (
  <section id="socios" className="relative py-20 md:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-5">
      {/* Membresías (Navy) */}
      <div className="relative overflow-hidden rounded-3xl bg-navy p-8 sm:p-12 min-h-[320px] flex flex-col justify-end">
        <div className="absolute -top-16 -right-10 h-64 w-64 rounded-full bg-gold/20 blur-3xl" />
        <div className="relative">
          <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-gold">
            <Star className="h-4 w-4" /> Hacete socio
          </span>
          <h3 className="mt-4 text-3xl sm:text-4xl font-black tracking-tight text-white leading-tight" style={{ fontFamily: "Outfit" }}>
            Sumate a la familia del club
          </h3>
          <p className="mt-3 text-white/80 max-w-md">
            Oro, Plata o Bronce. Acceso al predio, reserva del quincho, descuentos y beneficios para toda la familia.
          </p>
          <Link
            to="/membresias" data-testid="cta-membresias"
            className="group mt-6 inline-flex items-center gap-2 bg-gold text-navy font-bold px-6 py-3.5 rounded-xl hover:-translate-y-0.5 transition-transform"
          >
            Ver planes de socio <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>

      {/* Tienda (image + gold) */}
      <div className="relative overflow-hidden rounded-3xl bg-[#16235a] p-8 sm:p-12 min-h-[320px] flex flex-col justify-end">
        <img src={`${R2}/prod-50.jpg`} alt="Tienda oficial" loading="lazy"
          onError={(e) => (e.currentTarget.style.opacity = 0)}
          className="absolute inset-0 w-full h-full object-cover opacity-45" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/50 to-transparent" />
        <div className="relative">
          <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-gold">
            <ShoppingBag className="h-4 w-4" /> Tienda oficial
          </span>
          <h3 className="mt-4 text-3xl sm:text-4xl font-black tracking-tight text-white leading-tight" style={{ fontFamily: "Outfit" }}>
            Vestí los colores del Comandante
          </h3>
          <p className="mt-3 text-white/85 max-w-md">
            Camisetas, la edición especial 50 años e indumentaria oficial. Llevá el club con vos.
          </p>
          <Link
            to="/tienda" data-testid="cta-tienda"
            className="group mt-6 inline-flex items-center gap-2 bg-white text-navy font-bold px-6 py-3.5 rounded-xl hover:-translate-y-0.5 transition-transform"
          >
            Ir a la tienda <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </div>
  </section>
);
